import {BaseElement} from "./baseElement";
import {Box} from "../layout/box.ts";
import type {jsPDF} from "jspdf";
import {PdfMath} from "../shared/pdfMath.ts";

export class RichText2D extends BaseElement {
	kind = "rte" as const;
	color: string;
	fontFamily: string;
	fontWeight: string;
	fontSize: number;
	text: string;

	constructor(box: Box, id: string, fontFamily: string, fontWeight: string, fontSize: number, text: string, color: string) {
		super(box, id);
		this.text = text;
		this.color = color;
		this.fontFamily = fontFamily;
		this.fontWeight = fontWeight;
		this.fontSize = fontSize;
	}

	jsPdfUnitToPx(doc: jsPDF, valueInDocUnits: number, dpi = 96): number {
		const scaleFactor = doc.internal.scaleFactor; // pt per doc unit
		return valueInDocUnits * scaleFactor * (dpi / 72);
	}

	async draw(pdfDocument: jsPDF): Promise<void> {
		const box = this.box.getBoundingBox();
		const offsetY = pdfDocument.internal.pageSize.getHeight() + pdfDocument.getCurrentPageInfo().pageNumber;
		const widthInPixels = this.jsPdfUnitToPx(pdfDocument, box.width);
		const fontSizeInPixels = this.jsPdfUnitToPx(pdfDocument, PdfMath.toMm(this.fontSize));
		await pdfDocument.html(`<div class="rte">${this.text}</div>`, {
			x: box.x, y: box.y + offsetY, width: box.width,
			windowWidth: widthInPixels,
			margin: 0,
			html2canvas: {
				onclone(clonedDoc) {
					const style = clonedDoc.createElement("style");
					style.textContent = `
						* {
						 box-sizing: border-box !important;
						  border:0 !important;
						  margin: 0 !important;
						  margin-top: -${fontSizeInPixels + 5.4}px !important;
						  padding: 0 !important;
						  font-family: "Helvetica Neue", Arial, sans-serif !important;
						  font-size: ${fontSizeInPixels}px !important;
						}
      				`;
					clonedDoc.head.appendChild(style);
				}
			}
		});
	}
}
